import React, {Component} from 'react';
import {Link, withRouteData} from 'react-static';
import styled from 'styled-components';
import {Track, TrackedDiv, TrackDocument} from 'react-track';
import {topTop,
	topBottom,
	centerCenter,
	topCenter,
	bottomBottom,
	bottomTop,
	getDocumentRect,
	getDocumentElement,
	calculateScrollY} from 'react-track/tracking-formulas';
import {tween} from 'react-imation';

import Tower from '../resources/images/tower/tower.png';
import Base from '../resources/images/tower/base.png';
import Frame from '../resources/images/tower/frame.png';
import Box from '../resources/images/tower/box.png';
import Logo from '../resources/images/tower/logo.png';
import Oval1 from '../resources/images/tower/oval1.png';
import Oval2 from '../resources/images/tower/oval2.png';
import Oval3 from '../resources/images/tower/oval3.png';
import Oval4 from '../resources/images/tower/oval4.png';
import Oval5 from '../resources/images/tower/oval5.png';

import Flare4 from '../resources/images/flare-4.png';

const EnumerationStyle = styled.div`
	position: relative;
	
	.dots-digit {
		font-size: 3.125rem;
		font-weight: bold;
		color: #83F5F8;
	}
	
	.flare {
		top: 0px;
		opacity: 0.8;
		max-height: 100vh;
	}
	
	.dots-info {
		margin-bottom: 1.875rem;
		h4 {
			font-size: 1rem;
			text-shadow: 0 0 10px rgba(131, 245, 248, 0.30);
			font-weight: 400;
		}
		p {
			font-size: 1rem;
			opacity: 0.5;
		}
	}
	
	@media screen and (min-width: 64em) {
		margin-bottom: -6rem;
		.dots-more {
			position: relative;
			top: -200px;
		}
	
		.dots-overlay {
			position: absolute;
			top: 100px;
			left: 0;
			width: 100%;
		}
    }
    
	@media screen and (max-width: 63.9375em) {
		margin-top: 3.75rem;
		margin-bottom: 5rem;
	
		.dots-background {
			position: absolute;
			top: 0px;
			left: 0;
			width: 100%;
		}
    }
    
	@media screen and (max-width: 39.9375em) {
		margin-top: 3.75rem;
		margin-bottom: 6.25rem;
	
		.dots-background {
			position: relative;
		}
	
		.dots-overlay {
			position: relative;
		}
    }
    
    .live {
		padding-bottom: 154%;
	
		.oval1 {
			width: 12.6847%;
			height: 2.72218%;
			left: 43.5961%;
			top: 14.8118%;
			
			&-static {
				transform: scale(1.2);
			}
			
			&-filled0 {
				animation: anim-oval1-filled0 2s ease infinite;
			}
			
			&-filled1 {
				animation: anim-oval1-filled1 2s ease infinite;
			}
			
			&-filled2 {
				animation: anim-oval1-filled2 2s ease infinite;
			}
		}
		
		.oval2 {
			width: 22.7833%;
			height: 4.88391%;
			left: 38.5468%;
			top: 13.691%;
			animation: anim-oval2 2s ease infinite;
		}
		
		.oval3 {
			width: 38.67%;
			height: 8.2466%;
			left: 30.5419%;
			top: 12.2498%;
			animation: anim-oval3 2s ease infinite;
		}

		.oval4 {
			width: 58.3744%;
			height: 12.49%;
			left: 20.6897%;
			top: 10.1681%;
			animation: anim-oval4 2s ease infinite;
		}
		
		.oval5 {
			width: 85.2217%;
			height: 18.8151%;
			left: 7.26601%;
			top: 7.20576%;
			animation: anim-oval5 2s ease infinite;
		}
		
		.tower {
			width: 21.9212%;
			height: 76.7014%;
			left: 37.931%;
		    top: 15.252%;
		}
		
		.base {
			width: 21.5517%;
			height: 40.3523%;
			left: 46.6749%;
			top: 26.0208%;
		}
		
		.logo {
			width: 7.63547%;
			height: 4.96397%;
			left: 63.9163%;
			top: 45.7966%;
			opacity: 0;
			
			&-anim {
				animation: anim-box-logo 1s ease 1;
				opacity: 1;
			}
		}
		
		.frame {
			width: 17.3645%;
			height: 35.1481%;
			left: 48.6453%;
			top: 28.5829%;
			opacity: 0;
			
			&-anim {
				animation: anim-box-frame 1s ease 1;
			}
		}
		
		.box {
			width: 24.5074%;
			height: 31.4652%;
			left: 50.2463%;
			top: 31.7054%;
		}
	}
	
	@keyframes anim-oval1-filled0 {
	    0% {
			transform: scale(1);
			opacity: 1; 
        }
	    30% {
			transform: scale(2);
			opacity: 0; 
        }
	    50% {
			transform: scale(1);
			opacity: 0; 
	    }
	    100% {
			transform: scale(1);
			opacity: 0; 
	    }
	}
	
	@keyframes anim-oval1-filled1 {
	    0% {
			transform: scale(1);
			opacity: 1; 
        }
	    20% {
			transform: scale(1);
			opacity: 1; 
        }
	    75% {
			transform: scale(3);
			opacity: 0; 
        }
	    100% {
			transform: scale(1);
			opacity: 0; 
	    }
	}
	
	@keyframes anim-oval1-filled2 {
	    0% {
			transform: scale(1);
			opacity: 1; 
        }
	    20% {
			transform: scale(1);
			opacity: 1; 
        }
	    100% {
			transform: scale(5);
			opacity: 0; 
        }
	}
	
	@keyframes anim-oval2 {
	    0% {
			transform: scale(0);
			opacity: 1; 
        }
	    50% {
			opacity: 1; 
        }
	    100% {
			transform: scale(1.2);
			opacity: 0; 
        }
	}
	
	@keyframes anim-oval3 {
	    0% {
			transform: scale(0);
			opacity: 1; 
        }
	    50% {
			opacity: 1; 
        }
	    100% {
			transform: scale(1.3);
			opacity: 0; 
        }
	}
	
	@keyframes anim-oval4 {
	    0% {
			transform: scale(0);
			opacity: 1; 
        }
	    50% {
			opacity: 1; 
        }
	    100% {
			transform: scale(1.4);
			opacity: 0; 
        }
	}
	
	@keyframes anim-oval5 {
	    0% {
			transform: scale(0);
			opacity: 1; 
        }
	    50% {
			opacity: 1; 
        }
	    100% {
			transform: scale(1.5);
			opacity: 0; 
        }
	}
	
	@keyframes anim-box-frame {
	    0% {
			transform: scale(1);
			opacity: 1; 
        }
	    100% {
			transform: scale(1.5);
			opacity: 0; 
        }
	}
	
	@keyframes anim-box-logo {
	    0% {
			opacity: 0; 
        }
	    100% {
			opacity: 1; 
        }
	}
	
`;

class Enumeration extends Component {
	render() {

		return (
			<TrackDocument formulas={[getDocumentElement, getDocumentRect, calculateScrollY,
				topTop, topBottom, topCenter, centerCenter, bottomBottom,
				bottomTop]}>
				{(documentElement, documentRect, scrollY, topTop,
					topBottom, topCenter, centerCenter, bottomBottom, bottomTop) =>
					<EnumerationStyle>
						<img className="flare" src={Flare4} alt="Decorative background flare" />
						<div className="container">
							<div className="dots-background">
								<div className="row">
									<div className="columns medium-8 medium-offset-4">
										<div className="dots-container">
											<div className="live liveDots active">
												<TrackedDiv formulas={[topBottom, centerCenter, bottomTop]}>
													{(posTopBottom, posCenterCenter, posBottomTop) =>
														<div> {/* 1 : 0.75 */}
															<img src={Tower} className="tower" alt="ctr tower" style={{
																transformOrigin: "60% 0% 0px",
																transform: `scale(${tween(scrollY, [[ posTopBottom, 0.5 ], [ posBottomTop, 0.8 ]])}, 1)`,
															}}/>
															<img src={Base} className="base" alt="ctr base station" style={{
																transform: `translate3d(${tween(scrollY, [[ posTopBottom, 77.0813 ], [ posCenterCenter+200, 0 ]])}px, ${tween(scrollY, [[ posTopBottom, 57.811 ], [ posCenterCenter-200, 0 ]])}px, 0px)`
															}}/>
															<img src={Frame} alt="ctr box frame" className={`frame ${(tween(scrollY, [[ posCenterCenter+199, 0 ], [ posCenterCenter+200, 1 ]]) === 1 ? "frame-anim" : "")} `} />
															<img src={Box} alt="ctr box on tower" className="box" style={{
																transform: `translate3d(${tween(scrollY, [[ posTopBottom, 178.521 ], [ posCenterCenter+200, 0 ]])}px, ${tween(scrollY, [[ posTopBottom, 133.891 ], [ posCenterCenter-200, 0 ]])}px, 0px)`
															}}/>
															<img src={Logo} alt="ctr logo on box" className={`logo ${(tween(scrollY, [[ posCenterCenter+199, 0 ], [ posCenterCenter+200, 1 ]]) === 1 ? "logo-anim" : "")} `} style={{
																transform: `translate3d(${tween(scrollY, [[ posTopBottom, 178.521 ], [ posCenterCenter+200, 0 ]])}px, ${tween(scrollY, [[ posTopBottom, 133.891 ], [ posCenterCenter-200, 0 ]])}px, 0px)`
															}}/>
														</div>
													}</TrackedDiv>

												<img src={Oval1} className="oval1 oval1-static" alt="Inner signal" />
												<img src={Oval1} className="oval1 oval1-filled0" alt="Middle signal" />
												<img src={Oval1} className="oval1 oval1-filled1" alt="Middle signal" />
												<img src={Oval1} className="oval1 oval1-filled2" alt="Outer signal" />
												<img src={Oval2} className="oval2" alt="Animated inner signal" />
												<img src={Oval3} className="oval3" alt="Animated middle signal" />
												<img src={Oval4} className="oval4" alt="Animated middle signal" />
												<img src={Oval5} className="oval5" alt="Animated outer signal" />
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="dots-overlay">
								<div className="row">
									<div className="columns small-6 medium-3">
										<div className="dots-info">
											<div className="dots-digit">01.</div>
											<h4>{this.props.enumeration.list.fact01.header}</h4>
											<p>{this.props.enumeration.list.fact01.description}</p>
										</div>
									</div>
								</div>
								<div className="row">
									<div className="columns small-6 medium-3">
										<div className="dots-info">
											<div className="dots-digit">02.</div>
											<h4>{this.props.enumeration.list.fact02.header}</h4>
											<p>{this.props.enumeration.list.fact02.description}</p>
										</div>
									</div>
									<div className="columns small-6 medium-3">
										<div className="dots-info">
											<div className="dots-digit">04.</div>
											<h4>{this.props.enumeration.list.fact04.header}</h4>
											<p>{this.props.enumeration.list.fact04.description}</p>
										</div>
									</div>
								</div>
								<div className="row">
									<div className="columns small-6 medium-3">
										<div className="dots-info">
											<div className="dots-digit">03.</div>
											<h4>{this.props.enumeration.list.fact03.header}</h4>
											<p>{this.props.enumeration.list.fact03.description}</p>
										</div>
									</div>
									<div className="columns small-6 medium-3">
										<div className="dots-info">
											<div className="dots-digit">05.</div>
											<h4>{this.props.enumeration.list.fact05.header}</h4>
											<p>{this.props.enumeration.list.fact05.description}</p>
										</div>
									</div>
								</div>
							</div>
							<div className="row columns text-center dots-more">
								<Link className="button" to={`${this.props.language === "" ? "" : "/"}${this.props.language}/product`}>{this.props.enumeration.learnMore}</Link>
							</div>
						</div>
					</EnumerationStyle>
				}</TrackDocument>
		)
	}
}

export default withRouteData(Enumeration)


// WEBPACK FOOTER //
// /opt/build/repo/src/components/EnumerationScroll.js